<template lang="pug">
  .flow-builder-action-show-products-template
    template-tools(v-if="!disabled", @delete="$emit('delete')")
    .template-platforms-container.badges.mb-3(v-if="disabled")
      b-badge(v-for="(platform) in selectedPlatformsObjects.slice(0, sliceEnd)", :key="platform.platform_id", :style="{'background-color': platformColor(platform.name, 0.7)}") {{ platform.title }}
      b-badge(v-if="selectedPlatformsObjects.slice(sliceEnd).length", variant="soft-secondary") {{ selectedPlatformsObjects.slice(sliceEnd).length }} más
    .template-platforms-container.overflow-x.no-wrap.mb-3(v-else)
      b-form-group
        label.text-help.text-sm Plataformas donde se usará este template:
        k-select.disabled-white.flush(placeholder="- Agregar plataformas -", :options="parsedPlatforms", :disabled="disabled", :value="selected_platforms", @input="updatePlatforms", multiple, :limit="3", :searchable="false")
    b-card.mb-0.no-shadow.w-100.bg-light-white
      .bg-white.mb-2
        p.mb-0 Enviar HTML
        .my-3(:id="`html_${uuid}`")
</template>

<script>
import templateCommon from '../../helpers/template-common'
import TemplateTools from './common/Tools.vue'
import _debounce from 'lodash.debounce'
import pell from 'pell'
import uuid from "@/helpers/uuid-generator"

export default {
  mixins: [templateCommon],
  components: { TemplateTools },
  data () {
    return {
      editor: null,
      uuid: null
    }
  },
  methods: {
    initEditor () {
      const templateAttribute = this.getAttribute('body')
      const self = this

      const textActions = [
        'bold',
        'italic',
        'underline',
        'strikethrough',
        'heading1',
        'heading2',
        'quote',
        'olist',
        'ulist',
        'line'
      ]

      this.editor = pell.init({
        element: document.getElementById(`html_${self.uuid}`),
        onChange: html => {
          self.updateTemplateAttribute(templateAttribute, html)
        },
        actions: [
          ...textActions,
          {
            name: 'link',
            icon: '🔗',
            title: 'Link',
            result: () => {
              const url = window.prompt('Ingresa la URL:')
              if (url) pell.exec('createLink', url)
            }
          },
          {
            name: 'image',
            icon: '📷',
            title: 'Imagen',
            result: () => {
              const url = window.prompt('Ingresa la URL de la imagen:')
              if (url) pell.exec('insertImage', url)
            }
          }
        ],
        classes: {
          actionbar: ['d-flex justify-content-between border p-2 rounded-top'],
          button: 'btn btn-sm btn-soft-primary',
          selected: 'active',
          content: ['p-2 border border-top-0 rounded-bottom min-h-150']
        }
      });
      this.editor.content.innerHTML = templateAttribute ? templateAttribute.value : ''
    },
    update (template_attribute, value) {
      template_attribute.value = value
      const attribute = JSON.parse(JSON.stringify(template_attribute))
      attribute.value = value
      this.updateAttribute(this.block_id, this.template_id, attribute)
    },
    updateTemplateAttribute: _debounce(function (template_attribute, value) {
      this.update(template_attribute, value)

      this.$message.success('Actualizado')
    }, 2000, { leading: false, trailing: true })
  },
  mounted () {
    this.uuid = uuid('html_editor_xxxxxxxxxx')
    this.$nextTick(this.initEditor)
  },
}
</script>

<style lang="scss" scoped>

</style>
